import {
  Taxes,
  PropertyInformation,
  WaterInfo,
  AddedOmittedAssessment,
  ConfirmedAssessment,
  UnconfirmedAssessment,
  VprFee,
  Lien,
  SpecialImprovement,
  TaxExemption,
  PilotCharge,
} from 'components/forms/TaxSearches/NJTaxSearch/types';

export interface InPersonMunicipalityQueueTask {
  id: number;
  orderId: number;
  propertyId: number;
  searchId: number;
  address: string;
  municipality: string;
  block: string;
  lot: string;
  qualifier?: string;
  dateAdded: Date;
}

export interface SearchInfo {
  continOrUpdateNumber?: number;
  address: string;
  block: string;
  lot: string;
  qualifier: string;
  propertyId: number;
  municipalityId: number;
  municipality: string;
};

export interface TaxSearchValues {
  taxes: Taxes[];
  propertyInfo: PropertyInformation;
  water: WaterInfo[];
  addedAssessment: AddedOmittedAssessment[];
  confirmedAssessment: ConfirmedAssessment[];
  unconfirmedAssessment: UnconfirmedAssessment[];
  vprFees: VprFee[];
  liens: Lien[];
  specialImprovements: SpecialImprovement[];
  pilotCharges: PilotCharge[];
  taxExemptions: TaxExemption[];
  omittedAssessment: AddedOmittedAssessment[];
  vacantProperty: boolean;
  vacantPropertyAmount: string;
  feedDate: string;
  muaFeedDate: string;
  miscNote: string;
  titleForNote: string;
};

export const initialWaterInfo: WaterInfo = {
  type: { label: '', value: '' },
  description: { label: '', value: '' },
  additionalInfo: '',
  accountNumber: '',
  amount: '',
  status: { label: '', value: '' },
  priorAmountDue: '',
  priorAmountStatus: { label: '', value: '' },
  delinquentAmount: '',
  delinquentStatus: { label: '', value: '' },
  dateRange: '',
  waterInfoServiceLocation: '',
};

export const initialPropertyInformation: PropertyInformation = {
  municipalCode: '',
  assessTo: '',
  assessorCode: { value: '', label: '' },
  propertySize: '',
  landAssessment: '',
  totalAssessment: '',
  improvement: '',
  taxRate: '',
  taxRatio: '',
  taxRatioYear: { value: '', label: '' },
  mailingAddress: '',
  xLots: '',
  isBankruptcy: false,
  wippLinkAddress: '',
  feedDate: '',
  muaFeedDate: '',
  waterLink: '',
  qualDiscrepancy: false,
  addressDiscrepancy: false,
  inTaxSale: false,
  priorBLQ: '',
  serviceLocationDiscrepancy: false,
};

export const initialTaxSearchValues: TaxSearchValues = {
  taxes: [],
  propertyInfo: initialPropertyInformation,
  water: [initialWaterInfo],
  addedAssessment: [],
  confirmedAssessment: [],
  unconfirmedAssessment: [],
  vprFees: [],
  liens: [],
  specialImprovements: [],
  taxExemptions: [],
  pilotCharges: [],
  omittedAssessment: [],
  vacantProperty: false,
  vacantPropertyAmount: '',
  feedDate: '',
  muaFeedDate: '',
  miscNote: '',
  titleForNote: '',
};
